import { CapoPlugin } from "/var/www/lottobox-agent/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];